/**
 * 接口域名的管理
 */
 const normalizeEnvUrl = url => (url || '').replace(/^['"]|['"]$/g, '').trim();

 const base = {
    bd: normalizeEnvUrl(process.env.VUE_APP_URL),
    pay: normalizeEnvUrl(process.env.VUE_APP_PAY),
    newLink: normalizeEnvUrl(process.env.VUE_APP_NEW_BOX),
    // bd: 'https://testht4.guanying.xin',
    // cs:'https://testht4.guanying.xin',
    // lj:'https://testht4.guanying.xin',
    // tlr:'https://testht4.guanying.xin'
}
export default base;
